import { formatAmount } from "pages/Event/utils/formatAmount";

export const isZeroLike = (value: string): boolean => {
  return formatAmount(value || "0") === formatAmount("0");
};
